import { Component, OnInit } from '@angular/core';
import { ReferenceService } from '../services/reference.service';
import { TrackingService } from '../services/tracking.service';

@Component({
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.sass']
})

export class ErrorComponent implements OnInit {
  mspUrl;

  constructor(
    private referenceService: ReferenceService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.mspUrl = this.referenceService.staticReferences.DuoDomain;
    this.trackingService.pushEvent('financial-error_page');
  }
}
